import { z } from "zod";
import {
  APPROVE_AP_INVOICE_AMOUNT_LIMIT,
  APPROVE_PENALTIES_AMOUNT_LIMIT,
  DESCRIPTION,
  APPROVE_WORK_ORDER_AMOUNT_LIMIT,
  IS_APPROVE_AP_INVOICE,
  IS_APPROVE_PENALTIES,
  IS_APPROVE_WORK_ORDER,
  APPROVAL,
  APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT,
} from "./consts";
import { APPROVE_CONTRACT_AMOUNT_LIMIT } from "./consts";
import { IS_APPROVE_CONTRACT } from "./consts";
import { IS_ACTIVE } from "./consts";
import { APPROVED_BUDGET } from "./consts";
import { POSITION_NAME } from "./consts";

export const positionSchema = z.object({
  [POSITION_NAME]: z.string().min(5, "This field is required"),
  [APPROVED_BUDGET]: z.boolean().optional(),
  [IS_ACTIVE]: z.boolean().optional(),
  [IS_APPROVE_CONTRACT]: z.boolean().optional(),
  [APPROVE_CONTRACT_AMOUNT_LIMIT]: z.string().optional(),
  [IS_APPROVE_AP_INVOICE]: z.boolean().optional(),
  [APPROVE_AP_INVOICE_AMOUNT_LIMIT]: z.string().optional(),
  [APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT]: z.string().optional(),
  [IS_APPROVE_WORK_ORDER]: z.boolean().optional(),
  [APPROVE_WORK_ORDER_AMOUNT_LIMIT]: z.string().optional(),
  [IS_APPROVE_PENALTIES]: z.boolean().optional(),
  [APPROVE_PENALTIES_AMOUNT_LIMIT]: z.string().optional(),
  [DESCRIPTION]: z.string().optional(),
  [APPROVAL]: z.string().optional(),
});

export type positionFormValues = z.infer<typeof positionSchema>;
